import {
  ensureAppLocaleSessionSync,
  parseRouteLangQuery,
} from '~/composables/useAppLocale';

export default defineNuxtPlugin(nuxtApp => {
  const router = useRouter();

  const applyQueryLang = async (to = router.currentRoute.value) => {
    const raw = parseRouteLangQuery(to.query.lang);

    if (!raw) {
      return;
    }

    const i18n = nuxtApp.$i18n as { setLocale: (locale: string) => Promise<void> | void };
    await i18n.setLocale(raw);
  };

  const bootstrapLocale = async () => {
    await applyQueryLang();
    await ensureAppLocaleSessionSync();
  };

  bootstrapLocale();
  router.afterEach(to => {
    applyQueryLang(to);
  });
});
